import { keepPreviousData, useQuery } from '@tanstack/react-query';
import api from '@/axios';
import type { Paginated } from '@/types/core/paginated';
import type { Transit } from '@/types/core/transit/transit';
import type { DataTableQueryVariables } from '@/types/data-table';

export const GET_TRANSITS_KEY = ['transits', 'list'] as const;

export function useGetTransits({
  page = 1,
  perPage = 10,
  sort = [],
  filters = [],
}: DataTableQueryVariables<Transit>) {
  return useQuery({
    queryKey: [...GET_TRANSITS_KEY, page, perPage, sort, filters],
    queryFn: async ({ signal }): Promise<Paginated<Transit>> => {
      const response = await api.get<Paginated<Transit>>('/transits', {
        params: {
          page,
          perPage,
          sort: JSON.stringify(sort),
          filters: JSON.stringify(filters),
        },
        signal,
      });
      return response.data;
    },
    placeholderData: keepPreviousData,
    refetchInterval: (query) =>
      query.state.data?.data.some((transit) => transit.ddsNeedsRefresh)
        ? 60_000
        : false,
  });
}
